// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__KkQ1A","footer":"ChangeClinic_footer__1Y9Y9"};